module.exports = __webpack_public_path__ + "static/media/notes.34dd4c78.png";